import { EOrderTypeId } from "utils/payment/types";

export const ALL_PREMIUM_ORDER_TYPES: Array<EOrderTypeId> = [
  EOrderTypeId.PREMIUM_ACC_6_MONTHS,
  EOrderTypeId.PREMIUM_ACC_12_MONTHS,
  EOrderTypeId.PREMIUM_ACC_UNLIMITED,
];

export const PREMIUM_ORDER_TYPES: Array<EOrderTypeId> = [
  EOrderTypeId.PREMIUM_ACC_6_MONTHS,
  EOrderTypeId.PREMIUM_ACC_12_MONTHS,
  EOrderTypeId.PREMIUM_ACC_UNLIMITED,
];
